import React, { JSX, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { SubscriptionInvoice, SubscriptionInvoiceItem } from "../../../../../types/entities";
import { convertCurrencyToSymbol } from "../../../../../defaults/defaults";
import { useStripeModeFetch } from "../../../../global-hooks/default-system-hooks";
import { LinearProgress } from "@mui/material";
import { Link, useGetManyReference } from "react-admin";
import { ModalInvoiceItem } from "./subscription-manager-active-subscription-invoice-modal/ModalInvoiceItem";
import { CircularProgress } from "@mui/material";

export const SubscriptionManagerActiveSubscriptionInvoiceModal: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const invoice: SubscriptionInvoice = props.activeInvoice;
    const { isTestMode, loadingTestModeData } = useStripeModeFetch();
    const [activePage, setActivePage] = useState<number>(1);
    // console.log(invoice);

    const { data, isPending, error, total } = useGetManyReference(
        'subscription_invoice_items',
        {
            target: "subscriptionInvoices",
            id: invoice?.id,
            pagination: { page: activePage, perPage: 5 }
        },
    );

    function handleNextPage(): void {
        const newPage: number = activePage + 1;
        if (newPage < (total % 10)) {
            setActivePage(newPage);
        }
    }

    function handlePreviousPage(): void {
        const newPage: number = activePage - 1;
        if (newPage > 0) {
            setActivePage(newPage);
        }
    }

    return (
        <Dialog open={ props.open }
                fullWidth
                maxWidth="md"
                className="nn-invoice__viewer"
                onClose={ props.onClose }>
            <DialogTitle>
                <div style={ { width: '100%', display: 'flex', justifyContent: 'space-between' } }>
                    <span style={ { fontSize: '1.3rem', fontWeight: 'bold' }} >{ 'Invoice #' + invoice?.id }</span>
                    <button type="button"
                            onClick={ props.onClose }
                            style={ { cursor: 'pointer' } }>
                        <CloseIcon />
                    </button>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <div className="viewer__invoice">
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Id:" }</span>
                                <span className="data-row__value" >{ invoice?.id }</span>
                            </div>
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Status:" }</span>
                                <span className={ "data-row__value status " + invoice?.status }>{ invoice?.status }</span>
                            </div>
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Currency:" }</span>
                                <span className="data-row__value caps" >{ invoice?.currency }</span>
                            </div>
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Amount Due:" }</span>
                                <span className="data-row__value" >{ convertCurrencyToSymbol(invoice?.currency) + parseFloat(invoice?.amountDue)?.toFixed(2) }</span>
                            </div>
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Amount Paid:" }</span>
                                <span className="data-row__value" >{ convertCurrencyToSymbol(invoice?.currency) + parseFloat(invoice?.amountPaid)?.toFixed(2) }</span>
                            </div>
                            <div className="invoice__data-row">
                                <span className="data-row__title" >{ "Stripe Id:" }</span>
                                <span className="data-row__value" >
                                    { (loadingTestModeData) &&
                                        <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                                    }
                                    { (!loadingTestModeData && invoice) &&
                                        <span>
                                            { (isTestMode) &&
                                                <Link to={ "https://dashboard.stripe.com/acct_1S676LIYyPSARt7l/test/invoices/" + invoice.stripeId }
                                                      target="_blank"
                                                >{ invoice.stripeId }
                                                </Link>
                                            }
                                            {(!isTestMode) &&
                                                <Link to={ "https://dashboard.stripe.com/acct_1S676LIYyPSARt7l/invoices/" + invoice.stripeId }
                                                      target="_blank"
                                                >{ invoice.stripeId }
                                                </Link>
                                            }
                                        </span>
                                    }
                                </span>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={6}>
                        <div className="viewer__items">
                            { (isPending) &&
                                <div className="items__loader" >
                                    <span>{ "Loading invoice items..." }</span>
                                    <CircularProgress size={30} />
                                </div>
                            }

                            { (!isPending) &&
                                <>
                                    { (error) &&
                                        <div className="items__error" >
                                            <span>{ error.message }</span>
                                        </div>
                                    }
                                    { (data && data.length > 0) &&
                                        <>
                                            { data?.map( (item: SubscriptionInvoiceItem, index: number): JSX.Element => {

                                                return (
                                                    <ModalInvoiceItem key={ "invoice_item_" + index }
                                                                      invoiceId={ invoice?.id }
                                                                      invoiceItem={ item } />
                                                );
                                            } ) }
                                        </>
                                    }
                                </>
                            }
                        </div>
                        <div className="items__pagination">
                            <button type="button"
                                    disabled={ (total < 10) }
                                    onClick={ handlePreviousPage }>
                                <span>{ "<" }</span>
                            </button>
                            <span>{ activePage + '/' + ( total % 10 ) }</span>
                            <button type="button"
                                    disabled={ (total < 10) }
                                    onClick={ handleNextPage }>
                                <span>{ ">" }</span>
                            </button>
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}